// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__BHeuD","search":"Settings_search__2IkIb","filter":"Settings_filter__2hgYz"};